export default class TourStoreRegister {
  tourRegister = {};

  register(store) {
    const { key } = store;
    this.tourRegister[key] = store;
  }

  remove(key) {
    delete this.tourRegister[key];
  }

  get(key) {
    return this.tourRegister[key];
  }
}
